import {
  Routes,
  Route,
  Navigate,
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import MonitorDetailModal, {
  useOpenMonitorDetailModal,
} from "./MonitorDetailModal";

import MonitorPortfolio from "./PortfolioViews/MonitorPortfolio";
import { useTrueBizApi } from "../../api";
import useAdminSettings from "../../utilities/adminSettings";

export type Props = Record<string, never>;

export default function MonitoringV3() {
  const queryClient = useQueryClient();
  const api = useTrueBizApi();
  const navigate = useNavigate();

  const openModal = useOpenMonitorDetailModal();
  const [searchParams] = useSearchParams();
  const [settings] = useAdminSettings();

  const onOpenMonitorDetail = useCallback(
    (monitorDomain: string, issueId?: UUID) => {
      // TODO(drew): REMOVE ME ONCE TKHOME DEMO IS FINISHED
      if (settings.allowTKHomeMock === true && monitorDomain === "tkhome.ca") {
        navigate("/portfolio/tkhome.ca/latest");
        return;
      }

      queryClient.prefetchQuery({
        queryKey: ["getMonitor", monitorDomain],
        queryFn: () => api.getMonitoringEnrollment(monitorDomain),
      });

      setTimeout(() => openModal(monitorDomain, issueId), 200);
    },
    [openModal, queryClient, api, navigate, settings]
  );

  return (
    <>
      <Routes>
        <Route
          path="portfolio"
          element={
            <MonitorPortfolio onOpenMonitorDetail={onOpenMonitorDetail} />
          }
        />
        <Route
          path="*"
          element={
            // The target must stay absolute. A relative "portfolio" resolves
            // against the matched location rather than against /monitoring, so
            // a legacy url like /monitoring/issues/open redirects to
            // /monitoring/issues/open/portfolio -- which falls into this same
            // catch-all and redirects again, appending /portfolio forever
            // until the tab runs out of memory. See MonitoringAlerts.tsx for
            // the same bug in the alert deep link.
            <Navigate
              to={{
                pathname: "/monitoring/portfolio",
                search: searchParams.toString(),
              }}
              replace
            />
          }
        />
      </Routes>
      <MonitorDetailModal />
    </>
  );
}
